import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import {translateIcons} from 'config/constants';
import TagManagerService from 'services/TagManager';
import style from './style.scss';//NOSONAR

const ShelfCategory = (props) => {
    const category = props.category ? props.category : null;
    const position = props.position;

    const promotionClick = () => {
        const categoryClick = {
            url_banner: category.url,
            id: category.category,
            title: category.title,
            position: 'slot'+position,
            creative: 'category-click'
        };
        
        TagManagerService.promotionsClick(categoryClick);
    }

    const categoryParent = () => {
        const value = category.category ? ('cat-' + category.category.split("/")[0]) : '';
        return translateIcons[value] || value;
    };

    return (
        <div className="shelf-category-item">
            <Link to={category.url} className="shelf-category-icn" onClick={() => promotionClick()}>
                <i className={'font-icn-cat ' + categoryParent()}></i>
            </Link>
            <div className="shelf-category-info">
                <div className="shelf-category-brand">{category.title}</div>
            </div>
            <Link to={category.url} target={category.url_target} className="shelf-box-small-link" rel="noopener noreferrer" onClick={() => promotionClick()}>Ver categoría</Link>
        </div>
    )
}

ShelfCategory.propTypes = {
    category: PropTypes.object,
    small: PropTypes.bool,
    listTitle: PropTypes.string,
    position: PropTypes.number
};

export default ShelfCategory
